import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types';
import findKey from 'lodash.findkey';
import renderIf from 'render-if';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import { positionsArray, positions, positionNames, allYears, states,
         paginationKey, pagination, allGpa, gpaKey, statesArray } from 'constants/DropdownsValues';
import styles from './style.scss';


const styl = {
  positionWidth: {
    width: '250px',
  },
  yearWidth: {
    width: '150px',
  },
  labelStyle: {
    color: '#4a4a4a',
    fontSize: '12px',
    fontWeight: '400',
  },
  iconStyle: {
    color: 'blue',
  },
};

const items = [];
for (let i = 0; i < positionsArray.length; i++ ) { //eslint-disable-line
  items.push(<MenuItem value={i} key={i} primaryText={`${positionsArray[i]}`} />);
}

const yearsMenuItem = [];
for (let i = 0; i < allYears.length; i++ ) { //eslint-disable-line
  yearsMenuItem.push(<MenuItem value={i} key={i} primaryText={`${allYears[i]}`} />);
}

const paginationMenuItem = [];
for (let i = 0; i < pagination.length; i++ ) { //eslint-disable-line
  paginationMenuItem.push(<MenuItem value={i} key={i} primaryText={`${pagination[i]}`} />);
}

const gpaItems = [];
for (let i = 0; i < allGpa.length; i++ ) { //eslint-disable-line
  gpaItems.push(<MenuItem value={i} key={i} primaryText={`${allGpa[i]}`} />);
}

const statesItems = [];
for (let i = 0; i < statesArray.length; i++ ) { //eslint-disable-line
  statesItems.push(<MenuItem value={i} key={i} primaryText={`${statesArray[i]}`} />);
}

class Filter extends React.Component {
  static propTypes = {
    getDivisionStudents: PropTypes.func.isRequired,
    getFilteredDivisionStudents: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      positionIndex: 0,
      yearIndex: 0,
      gpaIndex: 0,
      statesIndex: 0,
      paginationIndex: 0,
      paginationValue: 20,
      positionValue: 'All Positions',
      selectedYear: 'All Years',
    };
  }
  handlePositionChange = (event, index, value) => {
    if (this.state.positionIndex !== index) {
      this.setState({ positionValue: value, positionIndex: index },
        this.handleFilterChange);
    }
  };
  handlePaginationChange = (event, index, value) => {
    if (this.state.paginationIndex !== index) {
      this.setState({ paginationValue: paginationKey[value], paginationIndex: index },
        this.handleFilterChange);
    }
  };
  handleYearChange = (event, index, value) => {
    if (this.state.yearIndex !== index) {
      this.setState({ selectedYear: allYears[value], yearIndex: index },
        this.handleFilterChange);
    }
  };

  handleGpaChange = (event, index, value) => {
    if (this.state.gpaIndex !== index) {
      this.setState({ gpaIndex: value }, this.handleFilterChange);
    }
  };

  handleStateChange = (event, index, value) => {
    if (this.state.statesIndex !== index) {
      this.setState({ statesIndex: value }, this.handleFilterChange);
    }
  };


  handleFilterChange = () => {
    const { paginationValue, paginationIndex, yearIndex, statesIndex,
            positionValue, selectedYear, positionIndex, gpaIndex } = this.state;
    const payload = {
      pagination: paginationValue,
      min_gpa: parseFloat(findKey(gpaKey, o => o === allGpa[gpaIndex])),
    };
    if (paginationIndex === 0 && positionIndex === 0 && yearIndex === 0 && statesIndex === 0
      && gpaIndex === 0) {
      this.props.getDivisionStudents();
    } else {
      if (yearIndex) payload['year_of_graduation'] = selectedYear; // eslint-disable-line
      if (positionIndex) {
        const positionKey = findKey(positions, o => o === positionsArray[positionValue]);
        const position = {
          position_value: positionKey,
          position_name: positionNames[positionKey],
        };
        payload['position'] = position; // eslint-disable-line
      }
      if (statesIndex) payload['state'] = findKey(states, o => o === statesArray[statesIndex]); // eslint-disable-line
      if (gpaIndex) payload['min_gpa'] = parseFloat(findKey(gpaKey, o => o === allGpa[gpaIndex])); // eslint-disable-line
      this.props.getFilteredDivisionStudents(payload);
    }
  };

  resetFilters = () => {
    this.setState({
      positionIndex: 0,
      yearIndex: 0,
      gpaIndex: 0,
      statesIndex: 0,
      paginationIndex: 0,
      paginationValue: 20,
      positionValue: 'All Positions',
      selectedYear: 'All Years',
    });
    this.props.getDivisionStudents();
  };

  render() {
    const { positionIndex, yearIndex, paginationIndex, gpaIndex, statesIndex,
      positionValue, selectedYear } = this.state;
    const renderClearFilter = renderIf(positionIndex !== 0 || yearIndex !== 0 || gpaIndex !== 0
                              || statesIndex !== 0 || paginationIndex !== 0 || positionValue !== 'All Positions'
                              || selectedYear !== 'All Years');
    return (
      <div className={cn('col s12', styles.remove_padding)}>
        <div>
          <DropDownMenu
            className={styles.paginationDropdown}
            value={paginationIndex}
            onChange={this.handlePaginationChange}
            autoWidth
            labelStyle={styl.labelStyle}
            maxHeight={300}
            iconStyle={styl.iconStyle}
          >
            {paginationMenuItem}
          </DropDownMenu>
        </div>
        <div>
          <DropDownMenu
            className={styles.dropDownMenu}
            value={yearIndex}
            onChange={this.handleYearChange}
            autoWidth
            labelStyle={styl.labelStyle}
            maxHeight={300}
            iconStyle={styl.iconStyle}
          >
            {yearsMenuItem}
          </DropDownMenu>
        </div>
        <div>
          <DropDownMenu
            className={styles.dropDownMenu}
            value={positionIndex}
            onChange={this.handlePositionChange}
            autoWidth
            labelStyle={styl.labelStyle}
            maxHeight={250}
            iconStyle={styl.iconStyle}
          >
            {items}
          </DropDownMenu>
        </div>
        <div>
          <DropDownMenu
            className={styles.dropDownMenu}
            value={gpaIndex}
            onChange={this.handleGpaChange}
            autoWidth
            labelStyle={styl.labelStyle}
            maxHeight={300}
            iconStyle={styl.iconStyle}
          >
            {gpaItems}
          </DropDownMenu>
        </div>
        <div className={cn('col s12', styles.remove_padding)}>
          <DropDownMenu
            className={styles.allStates}
            value={statesIndex}
            onChange={this.handleStateChange}
            autoWidth
            labelStyle={styl.labelStyle}
            maxHeight={300}
            iconStyle={styl.iconStyle}
          >
            {statesItems}
          </DropDownMenu>
          {renderClearFilter(
            <button onClick={this.resetFilters} className={styles.clearFilter} >
              Clear filter
            </button>,
          )}
        </div>
      </div>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/CoachDashboardView/components/DivisionBasedStudent/components/Filter/View.js